import { Card, Tag, Space, Typography } from "antd";
import { ClockCircleOutlined, BookOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import type { CourseListItem } from "@/api/catalog";

const { Title, Text, Paragraph } = Typography;

interface Props {
  course: CourseListItem;
}

export function CourseCard({ course }: Props) {
  return (
    <Link to={`/courses/${course.slug}`} style={{ textDecoration: "none" }}>
      <Card
        hoverable
        cover={
          course.cover_image ? (
            <img
              alt={course.name}
              src={course.cover_image}
              style={{ height: 160, objectFit: "cover" }}
            />
          ) : (
            <div
              style={{
                height: 160,
                background: "linear-gradient(135deg, #1677ff 0%, #69c0ff 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 32,
                fontWeight: 700,
              }}
            >
              {course.code}
            </div>
          )
        }
        style={{ height: "100%" }}
      >
        <Space direction="vertical" size="small" style={{ width: "100%" }}>
          <Title level={5} ellipsis={{ rows: 2 }} style={{ margin: 0, minHeight: 44 }}>
            {course.name}
          </Title>
          <Paragraph type="secondary" ellipsis={{ rows: 2 }} style={{ margin: 0, minHeight: 40 }}>
            {course.description || "Chưa có mô tả"}
          </Paragraph>
          <Space size={[4, 4]} wrap>
            {course.tags.map((t) => (
              <Tag key={t.id} color="blue">
                {t.name}
              </Tag>
            ))}
          </Space>
          <Space split="·" style={{ fontSize: 12, color: "#7a8499" }}>
            <Text type="secondary">
              <ClockCircleOutlined /> {course.credits} TC
            </Text>
            <Text type="secondary">
              <BookOutlined /> {course.lesson_count} bài
            </Text>
            {course.term_names.length > 0 && (
              <Text type="secondary">{course.term_names.join(", ")}</Text>
            )}
          </Space>
        </Space>
      </Card>
    </Link>
  );
}
